import { createContext, useContext } from 'react'
import { SimpleWorkspace } from '@opallabs/concepts'

export const WorkspaceContext = createContext<SimpleWorkspace | undefined>(
  undefined
)

export const useWorkspace = () => {
  const workspaceContext = useContext(WorkspaceContext)

  if (workspaceContext === undefined) {
    throw new Error(
      'useWorkspace must be used within a WorkspaceContext.Provider'
    )
  }

  return workspaceContext
}
